'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdArtTrack = function MdArtTrack(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm17.5 25l-3.7-5-2.9 3.8-2.1-2.5-2.9 3.7h11.6z m2.5-10v10c0 1.8-1.6 3.4-3.4 3.4h-10c-1.8 0-3.2-1.6-3.2-3.4v-10c0-1.8 1.4-3.4 3.2-3.4h10c1.8 0 3.4 1.6 3.4 3.4z m3.4 13.4v-3.4h13.2v3.4h-13.2z m13.2-16.8v3.4h-13.2v-3.4h13.2z m0 10h-13.2v-3.2h13.2v3.2z' })
        )
    );
};

exports.default = MdArtTrack;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/art-track.js
// module id = 745
// module chunks = 36573943044255 79611799117203 213534597649335